import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

// This will be called once from your app entry point
export const initGoogleMaps = async () => {
  // 1. Set global options
  setOptions({
    key: import.meta.env.VITE_GMAPS_API_KEY,
    version: 'weekly',
    // Note: The 'libraries' array in setOptions is for documentation only
    // Actual libraries must be loaded with importLibrary()
  });

  try {
    // 2. CRITICAL: Load the 'core' library first - this triggers the actual API download
    await importLibrary('core');
    
    // 3. Load other libraries in parallel for better performance
    await Promise.all([
      importLibrary('places'),
      importLibrary('geocoding'),
      importLibrary('marker')
    ]);
    
    console.log('Google Maps API loaded successfully');
    return true;
  } catch (error) {
    console.error('Error loading Google Maps API:', error);
    throw error;
  }
};